import React from "react"
import { Card, CardBody, Col, Container, Row } from "reactstrap"

// Gatsby Specific Imports
import { graphql, useStaticQuery } from "gatsby"

// icons
import { UilPresentationEdit } from "@iconscout/react-unicons"
import { UilAirplay } from "@iconscout/react-unicons"
import { UilImageCheck } from "@iconscout/react-unicons"

const WorkProcess = () => {
  const data = useStaticQuery(graphql`
    {
      markdownRemark(frontmatter: { contentKey: { eq: "aboutPage" } }) {
        frontmatter {
          work_process {
            heading
            sub_heading
            step_1 {
              step_1_heading
              sub_head_of_step_1
            }
            step_2 {
              step_2_heading
              sub_head_of_step_2
            }
            step_3 {
              step_3_heading
              sub_head_of_step_3
            }
          }
        }
      }
    }
  `)

  const { heading, sub_heading } = data.markdownRemark.frontmatter.work_process
  const { step_1_heading, sub_head_of_step_1 } =
    data.markdownRemark.frontmatter.work_process.step_1

  const { step_2_heading, sub_head_of_step_2 } =
    data.markdownRemark.frontmatter.work_process.step_2

  const { step_3_heading, sub_head_of_step_3 } =
    data.markdownRemark.frontmatter.work_process.step_3

  return (
    <>
      <Container>
        <Row className="justify-content-center">
          <Col xs={12}>
            <div className="section-title text-center mb-4 pb-2">
              <h6 className="text-primary">Work Process</h6>
              <h4 className="title mb-4">{heading}</h4>
              <p className="text-muted para-desc mx-auto mb-0">
                {/* Start working with{" "}
                <span className="text-primary fw-bold">copymedics</span> that
                can provide everything you need to generate awareness, drive
                traffic, connect. */}
                {sub_heading}
              </p>
            </div>
          </Col>
        </Row>

        <Row>
          <Col md={4} className="mt-4 pt-2">
            <Card className="features feature-clean work-process bg-transparent process-arrow border-0 text-center">
              <div className="icons text-primary text-center mx-auto">
                <i className="d-block rounded h3 mb-0">
                  <UilPresentationEdit size="30px" />
                </i>
              </div>

              <CardBody>
                <h5 className="text-dark">{step_1_heading}</h5>
                <p className="text-muted mb-0">{sub_head_of_step_1}</p>
              </CardBody>
            </Card>
          </Col>

          <Col md={4} className="mt-md-5 pt-md-3 mt-4 pt-2">
            <Card className="card features feature-clean work-process bg-transparent process-arrow border-0 text-center">
              <div className="icons text-primary text-center mx-auto">
                <i className="d-block rounded h3 mb-0">
                  <UilAirplay size="30px" />
                </i>
              </div>

              <CardBody>
                <h5 className="text-dark">{step_2_heading}</h5>
                <p className="text-muted mb-0">{sub_head_of_step_2}</p>
              </CardBody>
            </Card>
          </Col>

          <Col md={4} className="mt-md-5 pt-md-5 mt-4 pt-2">
            <Card className="features feature-clean work-process bg-transparent d-none-arrow border-0 text-center">
              <div className="icons text-primary text-center mx-auto">
                <i className="d-block rounded h3 mb-0">
                  <UilImageCheck size="30px" />
                </i>
              </div>

              <CardBody>
                <h5 className="text-dark">{step_3_heading}</h5>
                <p className="text-muted mb-0">{sub_head_of_step_3}</p>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default WorkProcess
